import React, { useState } from 'react'
import SignUpModal from '../SignUpModal';
import { toast } from "react-toastify";
import * as authService from "../../../services/authService.js";
import { StyledMainModalCont } from '../../../assets/styles/CommonStyles';

const CommonSignUpModal = ({ isSignUpModal, setSignUpModal, toggleSignUp }) => {
	const [selectUser, setSelectUser] = useState('');
	const [isMapping, setMapping] = useState(false);
	const [buttonLoading, setButtonLoading] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');

	// Map the display label to the API userType and persist it so
	// that SIGNUP() → getUser() resolves correctly at submit time.
	const handleSelectUser = (label) => {
		const typeMap = {
			'Normal user': 'patient',
			'Clinician / Hospital': 'organization',
		};
		const userType = typeMap[label] || 'patient';
		sessionStorage.setItem('userType', userType);
		setSelectUser(label);
	};

	const handleSubmit = async (orgUser) => {
		let phone = orgUser.countryCode.replace("+", "");
		const phone1 = orgUser.phoneNumber.replace(phone, "");
		const data = { ...orgUser, phoneNumber: phone1 }
		setButtonLoading(true);
		const res = await authService.signupApi(data);
		if (res.response_type === "fail") {
			setButtonLoading(false);
			toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: { width: 'auto', borderRadius: 8 } });
		} else {
			setButtonLoading(false);
			setSuccessMessage(res?.response?.message);
		}
	}

	const closeSuccess = () => {
		setSuccessMessage('');
		setSignUpModal(false);
	};

	return (
		<>
			{isSignUpModal && !successMessage &&
				<StyledMainModalCont>
					<SignUpModal
						selectUser={selectUser}
						isMapping={isMapping}
						isSignUpModal={isSignUpModal}
						setSignUpModal={setSignUpModal}
						toggleSignUp={toggleSignUp}
						setSelectUser={handleSelectUser}
						setMapping={setMapping}
						buttonLoading={buttonLoading}
						handleSubmit={handleSubmit}
					/>
				</StyledMainModalCont>
			}
			{successMessage &&
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						background: 'rgba(15, 23, 42, 0.55)',
						backdropFilter: 'blur(3px)',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						zIndex: 9999,
						padding: 16,
					}}
					onClick={closeSuccess}
				>
					<div
						style={{
							background: '#fff',
							borderRadius: 16,
							padding: '36px 32px 32px',
							maxWidth: 420,
							width: '100%',
							textAlign: 'center',
							boxShadow: '0 20px 60px rgba(15, 23, 42, 0.25)',
							fontFamily: 'inherit',
						}}
						onClick={(e) => e.stopPropagation()}
					>
						<div
							style={{
								width: 84,
								height: 84,
								borderRadius: '50%',
								background: 'rgba(34, 197, 94, 0.12)',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								margin: '0 auto 22px',
							}}
						>
							<div
								style={{
									width: 56,
									height: 56,
									borderRadius: '50%',
									background: '#22c55e',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									color: '#fff',
									fontSize: 30,
									fontWeight: 700,
									boxShadow: '0 6px 16px rgba(34, 197, 94, 0.4)',
								}}
							>
								✓
							</div>
						</div>
						<h3 style={{ fontSize: 22, fontWeight: 700, color: '#0f172a', margin: '0 0 10px' }}>
							Account Created
						</h3>
						<p style={{ fontSize: 15, lineHeight: 1.6, color: '#64748b', margin: '0 0 26px' }}>
							{successMessage}
						</p>
						<button
							onClick={closeSuccess}
							style={{
								width: '100%',
								background: '#16a34a',
								color: '#fff',
								border: 'none',
								borderRadius: 10,
								padding: '13px 0',
								fontSize: 16,
								fontWeight: 600,
								cursor: 'pointer',
							}}
						>
							Got it
						</button>
					</div>
				</div>
			}
		</>
	);
}

export default CommonSignUpModal;